import { pullAt } from 'lodash';
import { ILayerProps, MaterialIdsType } from '@/version-types';

// 删除预览信息
export const deleteFilterPreview = (layer: ILayerProps) => {
    const filterPreview = layer.__filterPreview;

    if (!filterPreview) return '';

    delete layer.__filterPreview;

    const filterIds = layer.materialIds?.[MaterialIdsType.FILTER];

    if (filterIds && filterIds[filterIds.length - 1] === filterPreview) {
        pullAt(filterIds, filterIds.length - 1);
    }

    return filterPreview;
};

// 添加一个滤镜id
export const appendFilterId = (layer: ILayerProps, filterID: string, unique = false) => {
    if (!filterID) return;

    if (!layer.materialIds) {
        layer.materialIds = {};
    }

    const filterIds = layer.materialIds[MaterialIdsType.FILTER];

    if (!filterIds) {
        layer.materialIds[MaterialIdsType.FILTER] = [filterID];
    } else {
        if (unique) {
            if (!filterIds.includes(filterID)) {
                filterIds.push(filterID);
            }
        } else {
            filterIds.push(filterID);
        }
    }
};
